<template>
  <div>
    <v-data-table item-key="id" :options.sync="busTableOptions" :items-per-page="10" :server-items-length="totalItems"
      :headers="headers" :footer-props="footerTable" :items="sbsentRequestList" sort-by="name" v-bind="this.$attrs"
      loading-text="Đang Tải" :loading="loading" no-data-text="Không có học sinh báo nghỉ " disable-sort>
      <template v-slot:[`item.date`]="{ item }">
        <span>{{ formatDate(item.date) }}</span>
      </template>
      <template v-slot:[`item.student.name`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <template v-slot:[`item.reason`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="truncate-text">{{ item.reason }}</span>
          </template>
          <span>{{ item.reason }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip small style="margin: 0" class="white--text" v-if="item.status"
          :color="item.status | absentRequestStatusColor" label>
          {{ item.status | absentRequestStatus }}
        </v-chip>
      </template>
      <template v-slot:[`item.data.name`]="{ item }">
        <router-link class="text-decoration-none" :to="getLink(item.data)">{{
          item.data && item.data.name
        }}</router-link>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="dialogDetail(item)" icon>
              <v-icon center color="grey darken-1">mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Xem chi tiết</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn :disabled="item.status === 'approved'" v-on="on" @click="approve(item)" icon>
              <v-icon center color="darken-1">mdi-checkbox-marked-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Phê duyệt</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <AbsentRequestDetailDialog :state="dialog" :absentRequestDetail="absentRequestDetail" />
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import AbsentRequestDetailDialog from '@/modules/absent-request/AbsentRequestDetailDialog.vue'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
const originHeaders = [
  {
    text: 'Học sinh',
    value: 'student.name',
    align: 'left',
  },
  {
    text: 'Lớp',
    value: 'studentClass.title',
    align: 'left',
  },
  {
    text: 'Ngày xin nghỉ',
    value: 'date',
    align: 'center',
  },
  {
    text: 'Lý do',
    value: 'reason',
    align: 'left',
  },
  {
    text: 'Trạng Thái',
    value: 'status',
    align: 'center',
  },
  {
    text: 'Người phê duyệt',
    value: 'data.name',
    align: 'center',
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
  }
]

export default {
  components: {
    CardStudentName,
    AbsentRequestDetailDialog
  },
  props: {},
  data() {
    return {
      headers: originHeaders,
      dialog: false,
      absentRequestDetail: null,
      busTableOptions: {}
    }
  },
  methods: {
    ...mapGetters('auth', ['profile']),
    ...mapActions('absentRequest', ['updateSbsentRequest', 'requestPageSettings']),
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    getLink(person) {
      if (person && person.id) {
        return `/staff/${person.id}`
      } else return '#'
    },
    async dialogDetail(item) {
      this.absentRequestDetail = item
      this.dialog = !this.dialog
    },
    async approve(data) {
      this.$dialog.confirm({
        title: 'Phê duyệt đơn xin nghỉ',
        text: `Bạn có muốn duyệt đơn xin nghỉ của học sinh ${data.student.name} vào ngày ${this.formatDate()} không?`,
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          this.$loading.active = true
          const query = {
            approvedBy: this.$auth.user.id
          }
          await this.updateSbsentRequest({ id: data.id, status: 'approved', data: this.profile(), ...query })
          this.$loading.active = false
        },
      })
    },
  },

  computed: {
    ...mapState('absentRequest', ['sbsentRequestList', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  watch: {
    busTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 400px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
